import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const EmailVerifiedRoute = ({ children }) => {
  const email = localStorage.getItem("email");
  const location = useLocation();

  if (!email) {
    // Redirect to verify-email, and remember where the user wanted to go
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  return children;
};

export default EmailVerifiedRoute;
